import React from 'react';
import { notify } from 'react-notify-toast';
import Select from 'react-select';
import {
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  HelpBlock,
  Alert
} from 'react-bootstrap';

import { optionsPosada } from 'constants/global';
import firebase  from 'firebase.js';

import './index.less';

const rules = [
  [],
  ['Усі питання що стосуються діяльності КБ УПЮ', 'Представлення питань та інтересів УПЮ на крайовому рівні в КПР'],
  ['Крайові заходи для юнацтва: зголошення, звітність, тощо.', 'Заміщення Крайового Булавного на час його відсутності'],
  ['Інформування та комунікація з Крайовою Булавою УПЮ', 'Ведення соціальної сторінки ФБ.'],
  ['Стратегія розвитку виховних частин в якісному і кількісному вираженні.'],
  ['Вдосконалення вишкільної системи', 'Ведення баз вишколів', 'Контроль за проведення вишколів та сприяння їх якісної організації'],
  ['Реєстрація спеціалізації', 'Зголошення спеціалізаційних вмілосте'],
  ['Впровадження нових вмілостей', 'Вимоги до нових вмілостей', 'Зголошення нових вмілостей'],
  ['Крайові табори : зголошення, звітування'],
  ['Усі питання, що стосують здобуття ступеня скоба/вірлиці та гетьманського скоба та вірлиці'],
  ['Здобуття КВ1,КВ2', 'Написання методичного проекту на здобуття КВ', 'Співпраця з Пластовою Банкою'],
  ['Питання, що стосуються наповнення юнацьких проб.', 'Вдосконалення програми УПЮ.'],
  ['']
];

export default class Home extends React.PureComponent {
  state = {
    name: '',
    bio: '',
    posada: 0,
    video: '',
    photo: '',
    email: '',
    opys: '',
    errorname: null,
    errorbio: null,
    errorvideo: null,
    erroremail: null,
    errorphoto: null,
    loading: false,
    sent: false
  };
  
  handleChange(field, value) {
    this.setState({ [field]: value });
    if (value.length > 0 || (field === 'posada' && value)) {
      this.setState({ [`error${field}`]: null });
    }
    if (field === 'email') {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
        this.setState({ erroremail: 'error' });
      } else {
        this.setState({ erroremail: null });
      }
    }
  }
  
  submitForm = async () => {
    this.setState({ loading: true });
    let error = false;
    let names = ['name', 'bio', 'posada', 'video', 'photo', 'email'];
    names.forEach(item => {
      if (!this.state[item]) {
        this.setState({ [`error${item}`]: true });
        error = true;
      }
    });
    if (error) {
      this.setState({ loading: false });
      return false;
    }
    const item = {
      name: this.state.name,
      posada: this.state.posada,
      bio: this.state.bio,
      video: this.state.video,
      photo: this.state.photo,
      email: this.state.email
    };
    if (this.state.opys) {
      item.opys = this.state.opys;
    }
    try {
      await firebase.database().ref('items').push(item);
      await firebase.database().ref(`posada/${this.state.posada}`).push(item);
      this.setState({
        name: '',
        posada: '',
        bio: '',
        video: '',
        photo: '',
        email: '',
        opys: ''
      });
      notify.show('Відправлено!', 'success');
      this.setState({ sent: true });
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <Row className="form">
        <Col xs={12}>
          <legend>Зголошення до складу КБ УПЮ 2018-2021</legend>
          <p>Ми дуже тішимось що ти цікавишся вступом до Крайової булави булави УПЮ 2018-2021! Та перед тим як ти перейдеш до заповнення форми, звертаємо твою увагу на те,  що склад КБ УПЮ може мінятись зборами МРСК, як і обов’язки, сталим є завдання крайової булави, а також роль Предсідника/-ці Скобиного Кругу. Якщо тобі цікаво працювати в Крайовій Булаві УПЮ, та ти не знайшов/-ла відповідної посади в списку, заохочуємо вибрати посаду «інша посада/роль» та описати що саме тобі було б цікаво робити протягом трьох років для розвитку Уладу.</p>
          <p>Зголошення буде відкритим до <b>22:00 20 жовтня 2018 року</b></p>
          <b>Вимоги до членів КБ УПЮ</b>
          <ul>
            <li>бути дійсним членом Пласту</li>
            <li>ступінь КВ 1</li>
          </ul>
        </Col>
        <Col xs={6}>
          <form>
            <FormGroup
              controlId="posada"
              validationState={this.state.errorposada && 'error'}
            >
              <ControlLabel>Посада</ControlLabel>
              <Select
                value={this.state.posada}
                options={optionsPosada}
                placeholder="Виберіть посаду"
                onChange={item => this.handleChange('posada', item.value || 0)}
                noResultsText="Немає результатів"
              />
            </FormGroup>
  
            {this.state.posada === 12 && (
              <FormGroup controlId="opys">
                <ControlLabel>Опис посади</ControlLabel>
                <HelpBlock>Опиши, що саме тобі було б цікаво робити впродовж трьох років для розвитку Уладу</HelpBlock>
                <FormControl
                  componentClass="textarea"
                  value={this.state.opys}
                  onChange={e => this.handleChange('opys', e.target.value)}
                />
              </FormGroup>
            )}
            
            <FormGroup
              controlId="name"
              validationState={this.state.errorname && 'error'}
            >
              <ControlLabel>Пластовий ступінь, Прізвище та Ім'я, Пластовий курінь</ControlLabel>
              <FormControl
                type="text"
                value={this.state.name}
                onChange={e => this.handleChange('name', e.target.value)}
              />
              <FormControl.Feedback />
            </FormGroup>
  
            <FormGroup
              controlId="email"
              validationState={this.state.erroremail && 'error'}
            >
              <ControlLabel>Email</ControlLabel>
              <FormControl
                type="email"
                value={this.state.email}
                onChange={e => this.handleChange('email', e.target.value)}
              />
              <FormControl.Feedback />
            </FormGroup>
  
            <FormGroup
              controlId="bio"
              validationState={this.state.errorbio && 'error'}
            >
              <ControlLabel>Коротка пластова біографія (згідно вимог на обрану посаду)</ControlLabel>
              <FormControl
                value={this.state.bio}
                componentClass="textarea"
                onChange={e => this.handleChange('bio', e.target.value)}
              />
            </FormGroup>
    
            <FormGroup
              controlId="video"
              validationState={this.state.errorvideo && 'error'}
            >
              <ControlLabel>Відео з баченням своєї ділянки</ControlLabel>
              <HelpBlock>Прохання коротко описати свою програму або як ти бачиш розвиток своєї ділянки</HelpBlock>
              <FormControl
                type="text"
                value={this.state.video}
                placeholder="Посилання на відео"
                onChange={e => this.handleChange('video', e.target.value)}
              />
              <FormControl.Feedback />
            </FormGroup>
            
            <FormGroup
              controlId="video"
              validationState={this.state.errorphoto && 'error'}
            >
              <ControlLabel>Посилання на твою фотографію, яку ми зможемо використовувавати для ознайомлення загалу з кандидатурами</ControlLabel>
              <HelpBlock>Бажано в пластовому однострої, якшо такої не має, то прохання надавати портретну</HelpBlock>
              <FormControl
                type="text"
                value={this.state.photo}
                placeholder="Посилання на фото"
                onChange={e => this.handleChange('photo', e.target.value)}
              />
              <FormControl.Feedback />
            </FormGroup>
  
            <Button
              className="btn-black"
              onClick={this.submitForm}
              disabled={this.state.loading}
            >
              Зголоситися
            </Button>
            
          </form>
        </Col>
        <Col xs={6}>
          {this.state.posada > 0 && this.state.posada !== 12 && (
            <React.Fragment>
              <b>Вимоги на обрану посаду</b>
              <ul>
                {rules[this.state.posada].map((item, i) => (<li key={i}>{item}</li>))}
              </ul>
            </React.Fragment>
          )}
        </Col>
        {this.state.sent && (
          <Col xs={12}>
            <Alert bsStyle="success" style={ { marginTop: '20px'} }>
              <h4>Твоє зголошення відправлено!</h4>
              <p>Номінаційна комісія сконтактує з Тобою по завершенні терміну зголошення й повідомить про формат представлення на самому МРСК, а також вивісить Твоє зголошення для загалу для ознайомлення.</p>
            </Alert>
          </Col>
        )}
      </Row>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/home/index.js